import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Workflow, WorkflowParentType, WorkflowRuleHistory, WorkflowRuleImplementation, WorkflowStep, WorkflowStepAction } from './workflow.model';
import { QueryParams, QueryResult } from '../../../core/store/models/query.model';
import { HttpService } from '../../../core/services/http.service';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class WorkflowApiService {
  constructor(private http: HttpService) {}

  public getWorkflowForDataset(datasetUId: string): Observable<QueryResult<Workflow>> {
    const params = {
      skip: 0,
      take: 1,
      where: `ParentUId=Guid.Parse("${datasetUId}")`,
      include: 'full'
    };

    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/meta/workflows?${queryString}`;

    return this.http.get<QueryResult<Workflow>>(url);
  }

  public updateWorkflow(workflow: Workflow): Observable<Workflow> {
    const url = `${apiBaseUrl}/v1/meta/workflows/${workflow.uId}?processChildData=true`;

    return this.http.put(url, workflow);
  }

  public getWorkflowStepActionsForStep(workflowUId: string, workflowStepUId: string): Observable<QueryResult<WorkflowStepAction>> {
    const params = {
      skip: 0,
      take: 100
    };

    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/meta/workflows/${workflowUId}/workflowSteps/${workflowStepUId}/workflowStepActions?${queryString}`;

    return this.http.get<QueryResult<Workflow>>(url);
  }

  public getWorkflowStepsForDeletion(workflowUId: string, workflowStepUId: string, datasetUId: string): Observable<WorkflowStep[]> {
    const url = `${apiBaseUrl}/v1/meta/workflows/${workflowUId}/workflowSteps/${workflowStepUId}/workflowStepsForDelete/${datasetUId}`;

    return this.http.get<WorkflowStep[]>(url);
  }

  // Workflow Rule Implementation
  public getRuleImplementations(): Observable<Array<WorkflowRuleImplementation>> {
    const url = `${apiBaseUrl}/v1/data/ruleImplementations`;

    return this.http.get<Array<WorkflowRuleImplementation>>(url);
  }

  // Workflow Rule History
  public getWorkflowRuleHistory(datasetUId: string, documentUId: string): Observable<QueryResult<WorkflowRuleHistory>> {
    const url = `${apiBaseUrl}/v1/data/datasets/${datasetUId}/workflow_rule/history_query/${documentUId}`;

    return this.http.post(url);
  }

  public getWorkflows(params: QueryParams): Observable<QueryResult<Workflow>> {
    const queryString = this.http.queryStringFromObject(params);

    const url = `${apiBaseUrl}/v1/meta/workflows?${queryString}`;

    return this.http.get<QueryResult<Workflow>>(url);
  }

  public deleteWorkflow(uid: string): Observable<Workflow> {
    const url = `${apiBaseUrl}/v1/meta/workflows/${uid}`;

    return this.http.delete(url);
  }

}
